import { ClientDTO } from 'wisestep-api';

import { INameAndId } from '../../../features/jobs/assign/types';

export interface IFilters {
  search: string;
  status: string[] | null;
  clientNameAndIds: INameAndId[];
  tags?: string[];
  clients: ClientDTO[];
}

export const contactsDefaultFilterValues = {
  search: '',
  status: ['Active'],
  clientNameAndIds: [],
  tags: [],
  clients: [],
};
